import { render, staticRenderFns } from "./PlayerNoOptaCard.vue?vue&type=template&id=c205be46&"
import script from "./PlayerNoOptaCard.vue?vue&type=script&lang=js&"
export * from "./PlayerNoOptaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports